import { ActionService, CommonService } from 'dashboard-services/services';

import { basicPipelineCreatorActions } from 'actions/modules/datascience';
import { basicCustomInsightActions } from 'actions/modules/insight';

import { NodeModel } from 'components/modules/Insight/CustomInsight/ChartInsight/tiles/DiagramTile/Content/Diagram/Node';

export default (() => {
  
  const DIAGRAM_VIEWS = {
    ADD_NODES: "ADD_NODES",
    NODE_DETAILS: "NODE_DETAILS"
  }

  const getReduxNodeFromState = ({ nodeId, index }) => (dispatch, getState) => {
    const tasks = (getState().insightState.customState.content?.tiles?.[index] || {})?.nodes

    return tasks?.[nodeId]
  }

  const DISCONNECT_REDUX_NODES = 'DISCONNECT_REDUX_NODES_CUSTOM_DIAGRAM_INSIGHT'
  const disconnectReduxNodes = ActionService.makeActionCreator(DISCONNECT_REDUX_NODES, 'id', 'tileIndex')
  
  const REMOVE_REDUX_NODE = "REMOVE_REDUX_NODE_CUSTOM_DIAGRAM_INSIGHT";
  const removeReduxNode = ({ nodeId, tileIndex }) => (dispatch, getState) => {
    const tile = getState().insightState.customState.content?.tiles?.[tileIndex] || {},
          node = tile.nodes[nodeId]
    if(node) {
      dispatch(removeReduxNodeReducer(nodeId, tileIndex))
    }
  }
  const removeReduxNodeReducer =  ActionService.makeActionCreator(REMOVE_REDUX_NODE, "nodeId", "tileIndex");

  const CHANGE_POSITION = 'CHANGE_POSITION_CUSTOM_DIAGRAM_INSIGHT'
  const changePosition = ActionService.makeActionCreator(CHANGE_POSITION, 'nodeId', 'position', 'tileIndex')

  const ADD_REDUX_NODE = "ADD_REDUX_NODE_CUSTOM_DIAGRAM_INSIGHT";
  const addReduxNode = ActionService.makeActionCreator(ADD_REDUX_NODE, "node", "tileIndex")

  const SET_ACTIVE_PORT = 'SET_ACTIVE_PORT_CUSTOM_DIAGRAM_INSIGHT'
  const setActivePort = ActionService.makeActionCreator(SET_ACTIVE_PORT, 'input', 'activeType', 'id', 'tileIndex')

  const CONNECT_NODES = 'CONNECT_NODES_CUSTOM_DIAGRAM_INSIGHT'
  const connectNodes = (outputParamName, outputParamTask, inputParamName, inputParamTask, id, tileIndex) => dispatch => {
    const link = {
      value: basicPipelineCreatorActions.generateDynamicId(),
      id,
      output: {
        name: outputParamName,
        task: outputParamTask
      },
      input: {
        name: inputParamName,
        task: inputParamTask
      }
    }
    dispatch(connectNodesReducer(link, tileIndex))
  }

  const connectNodesReducer = ActionService.makeActionCreator(CONNECT_NODES, 'link', 'tileIndex')

  const ON_CHANGE_REDUX_NODE = "ON_CHANGE_REDUX_NODE_DIAGRAM_INSIGHT"
  const onChangeReduxNode = ActionService.makeActionCreator(ON_CHANGE_REDUX_NODE, "value", "name", "nodeId", "tileIndex")

  const timeout = { current: undefined };
  const getNode = ({ point, nodeType, id = CommonService.generateUID(), tileIndex, withChangePosition = true }) => dispatch => {
    const node = new NodeModel(nodeType, id, tileIndex)
    node.setPosition(point);
    if(withChangePosition) {
      dispatch(changePosition(node.getId(), point, tileIndex))
    }
    node.registerListener({
      entityRemoved: e => {
        dispatch(removeReduxNode({ nodeId: e.entity.options.id, tileIndex }))
        dispatch(basicCustomInsightActions.onChange(undefined, "doubleClickedNode"))
      },
      positionChanged: e => {
        clearTimeout(timeout.current)
        timeout.current = setTimeout(() => dispatch(changePosition(e.entity.getId(), e.entity.getPosition(), tileIndex)), 500)
      }
    })
    return node;
  }

  return {
    DIAGRAM_VIEWS,
    getReduxNodeFromState,
    DISCONNECT_REDUX_NODES,
    disconnectReduxNodes,
    REMOVE_REDUX_NODE,
    removeReduxNode,
    CHANGE_POSITION,
    changePosition,
    addReduxNode,
    ADD_REDUX_NODE,
    setActivePort,
    SET_ACTIVE_PORT,
    connectNodes,
    CONNECT_NODES,
    onChangeReduxNode,
    ON_CHANGE_REDUX_NODE,
    getNode
  }
})()